"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconEarth3 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconEarth3, _Icon);
  function IconEarth3(props) {
    var _this;
    _classCallCheck(this, IconEarth3);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconEarth3).call(this, props));
    _this.name = 'IconEarth3';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "earth-3_svg__group0"
    }, _react2.default.createElement("path", {
      className: "earth-3_svg__path0",
      d: "M12 24a12.02 12.02 0 01-2.936-.366 11.959 11.959 0 01-7.153-5.149.751.751 0 01-.109-.171A11.952 11.952 0 010 12c0-2.234.623-4.416 1.801-6.313a.804.804 0 01.11-.173A11.976 11.976 0 0114.831.34a11.978 11.978 0 017.257 5.174.75.75 0 01.111.173A11.955 11.955 0 0124 12c0 2.234-.623 4.416-1.801 6.313a.744.744 0 01-.111.172A11.974 11.974 0 0112 24zm-2.246-1.745c.742.162 1.496.245 2.246.245s1.504-.083 2.246-.245c.563-.9 1.052-2.102 1.427-3.505H8.327c.375 1.404.864 2.605 1.427 3.505zm7.478-3.505a17.432 17.432 0 01-.945 2.832 10.476 10.476 0 003.747-2.832h-2.802zm-13.266 0a10.473 10.473 0 003.746 2.832 17.432 17.432 0 01-.945-2.832H3.966zm17.124-1.5a10.471 10.471 0 001.38-4.5h-4.481a29.288 29.288 0 01-.438 4.5h3.539zm-5.074 0c.271-1.409.433-2.951.472-4.5H7.512c.039 1.55.201 3.092.472 4.5h8.032zm-9.567 0a29.288 29.288 0 01-.438-4.5H1.53c.113 1.586.586 3.13 1.38 4.5h3.539zm16.021-6a10.471 10.471 0 00-1.38-4.5h-3.539c.255 1.418.402 2.928.438 4.5h4.481zm-5.982 0a27.852 27.852 0 00-.472-4.5H7.984a27.965 27.965 0 00-.472 4.5h8.976zm-10.477 0c.036-1.572.183-3.082.438-4.5H2.91a10.471 10.471 0 00-1.38 4.5h4.481zm14.023-6a10.467 10.467 0 00-3.747-2.832c.37.842.687 1.789.945 2.832h2.802zm-4.361 0c-.375-1.403-.864-2.605-1.427-3.505A10.482 10.482 0 0012 1.5c-.749 0-1.504.083-2.246.245-.563.9-1.052 2.101-1.427 3.505h7.346zm-8.905 0c.258-1.042.574-1.99.945-2.832A10.467 10.467 0 003.966 5.25h2.802z"
    })));
    return _this;
  }
  return IconEarth3;
}(_Icon3.default);
exports.default = IconEarth3;